"use strict";

exports.__esModule = true;
exports["default"] = stepper;

var errorMargin = 0.005;

function stepper(frameRate, x, v, destX, k, b) {
  if (k < 21) { // entering
    var numFrame = Math.round(0.8 / frameRate);

    if (numFrame == v || x > 0.99) return [destX, 0];
    else  return [v * v / (numFrame * numFrame), v + 1];
  } else { // leaving
    numFrame = Math.round(b / frameRate);

    if (numFrame == v || x < 0.01) return [destX, 0];
    else return [1 - v / numFrame, v + 1];
  }
}

module.exports = exports["default"];